import React,{useState, Suspense, useEffect} from "react";

import { useLocation, Navigate, Link } from "react-router-dom";
import { LoaderParts  } from '../Parts/loaderParts'
import { Useable } from '../../utils/Useable';
import { fetchCompCheck } from "../../data/fetch";



export const EntryCompPage = () => {

    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const id = query.get('id')
    const [res, setRes] = useState(0)


    useEffect(() => {
        fetchCompCheck(id).then((res) => {
            setRes(res.respons)
        })
    },[]);

    
    if(id === null) {
        return  <Navigate replace to="/"/>

    }else{

        return (
            <div className="select">
            {
                res !== 0 && 
                <>
                {
                res === 'success' &&
                    <div className="complete">
                        <div className="complete_img">
                            <img src={`${process.env.REACT_APP_HOME_URL}/images/complete.png`}/>
                        </div>
                        <div className="complete_mes">ご応募を受け付けました</div>
                        <div className="complete_desc">当選した方には、ご契約の販売店からお知らせいたします。</div>
                    </div>
                }
                {
                res === 'error' &&
                    <div className="complete">   
                        <div className="select_desc al-c">申し訳ございません。<br/>エラーが発生し、<br/>応募を受け付けられませんでした。</div>
                    </div>
                }
            
                </>
            }
            <div className="select_content mt-40">
                <div className="tile a2 am20-bm30-cm50 jc">
                    <div>
                    <Link className="btn3"
                        to={`/`}>もどる</Link>
                    </div>
                </div>
            </div>
            </div>
        )
    }

}